import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { useSortingContext } from 'utils/contexts/sorting';
import { isValidEnumValue } from 'utils/tsHelpers';

export const useSetSortDirection = () => {
  const { setSortDirection } = useSortingContext();
  return (direction: string) => {
    if (isValidEnumValue(direction, SORT_DIRECTIONS)) setSortDirection(direction);
  };
};
